const mediaItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Street%20photography%20abstract%20composition%20with%20warm%20golden%20hour%20lighting%2C%20urban%20night%20scene%20with%20dramatic%20amber%20and%20deep%20coral%20tones%2C%20paparazzi%20style%20atmosphere%2C%20editorial%20photography%2C%20moody%20cinematic%20aesthetic&width=800&height=500&seq=media-card-01&orientation=landscape',
    tag: '独家视频',
    title: '某明星街头被拍，疑似新恋情曝光',
    duration: '02:34',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Breaking%20news%20scene%20abstract%20composition%20with%20dramatic%20warm%20lighting%2C%20emergency%20response%20concept%2C%20dark%20moody%20background%20with%20amber%20and%20rose%20highlights%2C%20photojournalism%20aesthetic%2C%20cinematic&width=800&height=500&seq=media-card-02&orientation=landscape',
    tag: '现场直击',
    title: '某地突发重大事件第一手画面',
    duration: '05:18',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Interview%20studio%20abstract%20composition%20with%20warm%20spotlight%20and%20dark%20background%2C%20professional%20interview%20setting%20concept%2C%20golden%20amber%20lighting%20with%20deep%20coral%20accents%2C%20documentary%20film%20aesthetic%2C%20editorial&width=800&height=500&seq=media-card-03&orientation=landscape',
    tag: '深度访谈',
    title: '业内人士独家披露行业不为人知的潜规则',
    duration: '12:06',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3 tracking-tight">
          精彩视频
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10">
          独家影像 · 第一手现场
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5 max-w-5xl mx-auto">
          {mediaItems.map((item, i) => (
            <a
              key={i}
              href="#"
              onClick={(e) => e.preventDefault()}
              className="group block rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200/60 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 md:h-56 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-background-950/20 group-hover:bg-background-950/30 transition-colors duration-300 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-background-50/90 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <i className="ri-play-fill text-2xl text-primary-600 ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute top-3 left-3 text-[10px] font-bold px-2 py-1 rounded bg-accent-500 text-background-50 whitespace-nowrap">
                  {item.tag}
                </span>
                <span className="absolute bottom-3 right-3 text-[10px] font-medium px-2 py-1 rounded bg-background-950/70 text-background-50 whitespace-nowrap">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading font-semibold text-foreground-900 text-sm group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3 mt-2">
                  <span className="text-foreground-400 text-[11px]">
                    <i className="ri-eye-line mr-1"></i>{(Math.random() * 20 + 5).toFixed(1)}万
                  </span>
                  <span className="text-foreground-400 text-[11px]">
                    <i className="ri-thumb-up-line mr-1"></i>{Math.floor(Math.random() * 3000 + 500)}
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}